import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { documentsDetailComponent } from './documentsDetail.component';

@NgModule({
  declarations: [documentsDetailComponent],
  imports: [TranslateModule, CommonModule, RouterModule],
  exports: [documentsDetailComponent]
})
export class DocumentsDetailModule { }
